/*
    * Handler functions that perform modifications of data in the state tree
*/
import { MutationTree } from "vuex";
import { About } from "./types";

/*
    * Computed properties
*/
export const mutations: MutationTree<About> = {
    /*
        * Dialog close event
    */
    _aboutDialogClose(state, payload) {
        //#.Remove component in the DOM
        state.dialog = false;
    }
};
